import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
export var ALIGN_SELF_KEY = ['alignSelf'];
export var FLEX_KEY = ['flex'];
export var MARGIN_KEY = ['m', 'margin', 'mt', 'marginTop', 'mr', 'marginRight', 'mb', 'marginBottom', 'ml', 'marginLeft', 'mx', 'marginX', 'my', 'marginY'];
export var ORDER_KEY = ['order'];
export var PADDING_KEY = ['p', 'padding', 'pt', 'paddingTop', 'pr', 'paddingRight', 'pb', 'paddingBottom', 'pl', 'paddingLeft', 'px', 'paddingX', 'py', 'paddingY'];
export var TEXT_TRANSFORM_KEY = ['textTransform'];
export var VERTICAL_ALIGN_KEY = ['verticalAlign'];
export var WIDTH_KEY = ['width'];
export var MAX_WIDTH_KEY = ['maxWidth'];
export var MIN_HEIGHT_KEY = ['minHeight'];
export var MAX_HEIGHT_KEY = ['maxHeight'];
export function fallbackValues() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.find(function (value) {
    return typeof value !== 'undefined';
  });
}
export var cssAlignSelf = function (props) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  styles.alignSelf = props.alignSelf;
  return styles;
};
export var cssFlex = function (props) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  styles.flex = props.flex;
  return styles;
};
export var cssMargin = function (props) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var m = props.m,
      margin = props.margin,
      mt = props.mt,
      marginTop = props.marginTop,
      my = props.my,
      marginY = props.marginY,
      mr = props.mr,
      marginRight = props.marginRight,
      mx = props.mx,
      marginX = props.marginX,
      mb = props.mb,
      marginBottom = props.marginBottom,
      ml = props.ml,
      marginLeft = props.marginLeft;
  styles.margin = fallbackValues(m, margin);
  styles.marginTop = fallbackValues(mt, marginTop, my, marginY);
  styles.marginRight = fallbackValues(mr, marginRight, mx, marginX);
  styles.marginBottom = fallbackValues(mb, marginBottom, my, marginY);
  styles.marginLeft = fallbackValues(ml, marginLeft, mx, marginX);
  return styles;
};
export var cssOrder = function (props) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  styles.order = props.order;
  return styles;
};
export var cssPadding = function (props) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var p = props.p,
      padding = props.padding,
      pt = props.pt,
      paddingTop = props.paddingTop,
      py = props.py,
      paddingY = props.paddingY,
      pr = props.pr,
      paddingRight = props.paddingRight,
      px = props.px,
      paddingX = props.paddingX,
      pb = props.pb,
      paddingBottom = props.paddingBottom,
      pl = props.pl,
      paddingLeft = props.paddingLeft;
  styles.padding = fallbackValues(p, padding);
  styles.paddingTop = fallbackValues(pt, paddingTop, py, paddingY);
  styles.paddingRight = fallbackValues(pr, paddingRight, px, paddingX);
  styles.paddingBottom = fallbackValues(pb, paddingBottom, py, paddingY);
  styles.paddingLeft = fallbackValues(pl, paddingLeft, px, paddingX);
  return styles;
};
export var cssTextTransform = function (props) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  styles.textTransform = props.textTransform;
  return styles;
};
export var cssVerticalAlign = function (props) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  styles.verticalAlign = props.verticalAlign;
  return styles;
};
export var cssWidth = function (props) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  styles.width = props.width;
  return styles;
};
export var cssMaxWidth = function (props) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  styles.maxWidth = props.maxWidth;
  return styles;
};
export var cssMinHeight = function (props) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  styles.minHeight = props.minHeight;
  return styles;
};
export var cssMaxHeight = function (props) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  styles.maxHeight = props.maxHeight;
  return styles;
};
export var composeStyles = function (componentProps, systemProps) {
  var styles = {};
  if (!componentProps || !Array.isArray(systemProps)) return styles;
  systemProps.forEach(function (sp) {
    if (!sp) return;
    sp(componentProps, styles);
  });
  Object.entries(styles).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    if (!val && val !== 0) delete styles[key];
  });
  return styles;
};
export var removeSystemProps = function (componentProps, systemPropsKeys) {
  var newComponentProps = _objectSpread({}, componentProps);

  if (!componentProps || !Array.isArray(systemPropsKeys)) {
    return newComponentProps;
  }

  systemPropsKeys.forEach(function (keys) {
    if (!Array.isArray(keys)) return;
    keys.forEach(function (key) {
      return delete newComponentProps[key];
    });
  });
  return newComponentProps;
};